import { Observable } from 'rxjs/Observable';
import { LocalStorageService } from './local-storage.service';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from './../../environments/environment';
import { AutenticacaoService } from './autenticacao.service';
import { Usuario } from './../models/usuario';

@Injectable()
export class UsuarioService {

  private API_URL: string = environment.apiUrl;

  constructor(
    private http: Http,
    private autenticacaoService: AutenticacaoService,
    private localStorage: LocalStorageService
  ) { }

  /**
   *Usuários do CMS 
   */
  public obterUsuario(id: number): Observable<Usuario> {
    return this.http.get(`${this.API_URL}usuarios/${id}`)
      .map(response => response.json(), error => error.json());
  }

  public obterUsuariosFiltro(
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number  
  ): Observable<Array<Usuario>> {
    return this.http.get(`${this.API_URL}usuarios/filtro?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}`)
      .map(response => response.json(), error => error.json());
  }

   public obterUsuariosPesquisa(
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number,
    termo : string
  ): Observable<Array<Usuario>> {
    return this.http.get(`${this.API_URL}usuarios/pesquisa?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}&termo=${termo}`)
      .map(response => response.json(), error => error.json());
  }

  public obterListaUsuario(): Observable<Array<Usuario>> {
    return this.http.get(`${this.API_URL}usuarios`)
      .map(response => response.json(), error => error.json());
  }

  public adicionarUsuario(usuario: Usuario): Observable<any> {
    return this.http.post(`${this.API_URL}usuarios`, JSON.stringify(usuario))
      .map(response => response.json(), error => error.json());
  }

  public atualizarUsuario(id: number, usuario: Usuario): Observable<any> {
    return this.http.put(`${this.API_URL}usuarios/${id}`, JSON.stringify(usuario))
      .map(response => response.json(), error => error.json());
  }

  public excluirUsuario(usuarios: Array<Usuario>): Observable<any> {
    return this.http.put(`${this.API_URL}usuarios/Delete`, JSON.stringify(usuarios))
      .map(response => response.json(), error => error.json());
  }

  /**
   *Usuários dos APP 
   */
  public obterListaUsuarioApp(): Observable<any> {
    return this.http.get(`${this.API_URL}usuarios/usuariosapp`)
      .map(response => response.json(), error => error.json());
  }

  public obterListaUsuarioAppFiltro(
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number,
    modulo: string
  ): Observable<Array<any>> {
    return this.http.get(`${this.API_URL}usuarios/usuariosapp/filtro?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}&modulo=${modulo}`)
      .map(response => response.json(), error => error.json());
  }

  public obterListaUsuarioAppPesquisar(
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number,
    nome: string,
    codigo: string,
    dataNascimentoInicial: string,
    dataNascimentoFinal : string,    
    dataInicioCooperativa : string,
    dataFimCooperativa : string,
    sexo: string,
    modulo: string,
    status : number,
    tipoContratacao?: string,
    tipoPlano?: string
  ): Observable<Array<any>> {
    let termo = "";
    if(nome) {
      termo = `&nome=${nome}`;
    }
    if(codigo) {
      termo += `&codigo=${codigo}`;
    }
    return this.http.get(`${this.API_URL}usuarios/usuariosapp/pesquisa?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}${termo}&dataNascimentoInicial=${dataNascimentoInicial}&dataNascimentoFinal=${dataNascimentoFinal}&dataInicioCooperativa=${dataInicioCooperativa}&dataFimCooperativa=${dataFimCooperativa}&sexo=${sexo}&modulo=${modulo}&status=${status}&tipoContratacao=${tipoContratacao}&tipoPlano=${tipoPlano}`)
      .map(response => response.json(), error => error.json());
  }

  public obterQuantidadePaginasUsuarioAppPesquisar(
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number,
    nome: string,
    codigo: string,
    dataNascimentoInicial: string,
    dataNascimentoFinal : string,    
    dataInicioCooperativa : string,
    dataFimCooperativa : string,
    sexo: string,
    modulo: string,
    tipoContratacao: string,
    tipoPlano: string
  ): Observable<Array<any>> {
    let termo = "";
    if(nome) {
      termo = `&nome=${nome}`;
    }
    if(codigo) {
      termo += `&codigo=${codigo}`;
    }       
    return this.http.get(`${this.API_URL}usuarios/usuariosapp/quantidadePaginasPesquisa?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}${termo}&dataNascimentoInicial=${dataNascimentoInicial}&dataNascimentoFinal=${dataNascimentoFinal}&dataInicioCooperativa=${dataInicioCooperativa}&dataFimCooperativa=${dataFimCooperativa}&sexo=${sexo}&modulo=${modulo}&tipoContratacao=${tipoContratacao}&tipoPlano=${tipoPlano}`)
      .map(response => response.json(), error => error.json());
  }

  public obterListaUsuarioAppPesquisarPorEspecialidade(
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number,
    especialidadeCodigo: number,
    status : number
  ): Observable<Array<any>> {
    return this.http.get(`${this.API_URL}usuarios/usuariosapp/pesquisaEspecialidade?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}&especialidadeCodigo=${especialidadeCodigo}&status=${status}`)
      .map(response => response.json(), error => error.json());
  }

  public obterQuantidadeUsuarios(itensPorPagina : number, termo: string) : Observable<number>{
    let uri: string;
    if(termo){
      uri = `${this.API_URL}Usuarios/quantidade?itensPorPagina=${itensPorPagina}&termo=${termo}`
    }else{
      uri = `${this.API_URL}Usuarios/quantidade?itensPorPagina=${itensPorPagina}`
    }
    return this.http.get(uri)
                    .map(
                      response => response.json(),
                      error => error.json()
                    );
  }

  public obterQuantidadePaginasUsuarioAppPesquisarPorEspecialidade(
    itemOrdenar: string,
    ordenacao: string,
    itensPorPagina: number,
    pagina: number,
    especialidadeCodigo: number
  ): Observable<Array<any>> {
    return this.http.get(`${this.API_URL}usuarios/usuariosapp/quantidadePaginasPorEspecialidade?itemOrdenar=${itemOrdenar}&ordenacao=${ordenacao}&itensPorPagina=${itensPorPagina}&pagina=${pagina}&especialidadeCodigo=${especialidadeCodigo}`)
      .map(response => response.json(), error => error.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/app-services/usuario.service.ts